
import React from 'react';

const SteeringWheelUnderline = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="32"
			height="32"
			fill="none"
			viewBox="0 0 32 32"
		>
			<path
				fill="#2d2d2d"
				d="M16 26c6.62 0 12-5.38 12-12S22.62 2 16 2 4 7.38 4 14s5.38 12 12 12zm0-22c5.51 0 10 4.49 10 10s-4.49 10-10 10S6 19.51 6 14 10.49 4 16 4z"
			></path>
			<path
				fill="#2d2d2d"
				d="M14.34 22.84c.04.01.07.01.11.02.24.04.47.08.71.1.28.03.56.04.84.04.28 0 .56-.01.84-.04.24-.02.48-.06.71-.1.04-.01.07-.01.1-.01 4-.75 7.06-4.15 7.31-8.3l.01-.11c.02-.15.03-.3.03-.44 0-.3-.02-.6-.05-.89-.01-.14-.04-.27-.06-.4-.02-.15-.04-.31-.07-.46-.04-.18-.09-.36-.14-.55-.03-.1-.05-.2-.08-.3-.05-.2-.12-.4-.2-.59-.03-.07-.05-.14-.07-.21l-.01-.01a8.986 8.986 0 00-16.64 0l-.01.01c-.03.07-.05.14-.07.21-.08.19-.15.39-.21.59-.03.1-.05.2-.08.3-.05.18-.1.36-.14.55-.03.15-.05.31-.07.46-.02.13-.05.27-.06.4-.02.29-.04.59-.04.89 0 .14.01.29.02.43l.01.11a9.005 9.005 0 007.31 8.3zm8.32-11c.09.27.16.55.21.83l.03.17c.04.22.06.44.08.66 0 .04 0 .09.01.13-3.48.79-6.09 3.73-6.46 7.34-.04 0-.08 0-.11.01-.27.02-.54.02-.81 0-.04 0-.07 0-.11-.01a8.36 8.36 0 00-6.47-7.34c0-.04 0-.09.01-.13.02-.22.04-.44.08-.66a7.754 7.754 0 01.24-1c0-.01.01-.02.01-.03 4.23-1.07 9.06-1.07 13.29 0-.01.01-.01.02 0 .03zM9.24 15.79c2.09.72 3.66 2.49 4.13 4.69a7.028 7.028 0 01-4.13-4.69zm9.38 4.7a6.367 6.367 0 014.14-4.7 7.037 7.037 0 01-4.14 4.7zM16 7c2.14 0 4.06.97 5.35 2.49-3.49-.64-7.21-.64-10.7 0A7.008 7.008 0 0116 7z"
			></path>
			<path fill="#2d2d2d" d="M18 12h-4v2h4v-2zM25 30H7v2h18v-2z"></path>
		</svg>
	);
};

export default SteeringWheelUnderline;
